import { Extension as d } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { TextSelection as f, AllSelection as m } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { LINE_HEIGHT_ATTRIBUTE as r, LINE_HEIGHT_TYPES as u } from "./constants.mjs";
function p(e, n, i) {
  const t = e.doc.nodeAt(n);
  if (!t) return e;
  const o = {
    ...t.attrs,
    [r]: i
  };
  return e.setNodeMarkup(n, t.type, o, t.marks);
}
function s(e, n) {
  const { doc: i, selection: t } = e;
  if (!i || !t || !(t instanceof f || t instanceof m))
    return e;
  const { from: o, to: l } = t;
  return i.nodesBetween(o, l, (c, a) => u.includes(c.type.name) ? (e = p(e, a, n), !1) : !0), e;
}
const H = (e) => {
  const n = e.style.lineHeight;
  if (!n || n === "normal") return null;
  const i = n.replace(/['"]+/g, ""), t = parseFloat(i);
  return Number.isNaN(t) ? null : /[a-z%]/i.test(i) ? i : t;
}, T = d.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: u
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [r]: {
            default: null,
            parseHTML: (e) => H(e),
            renderHTML: (e) => e[r] ? {
              style: `line-height: ${e[r]}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ tr: n, state: i, dispatch: t }) => {
        const { selection: o } = i;
        return n = n.setSelection(o), n = s(n, e), n.docChanged ? (t && t(n), !0) : !1;
      },
      unsetLineHeight: () => ({ tr: e, state: n, dispatch: i }) => {
        const { selection: t } = n;
        return e = e.setSelection(t), e = s(e, null), e.docChanged ? (i && i(e), !0) : !1;
      }
    };
  }
});
export {
  r as LINE_HEIGHT_ATTRIBUTE,
  u as LINE_HEIGHT_TYPES,
  T as LineHeightExtension
};
